import Dashboard from "../../../../common/components/layout/Dashboard";
import Toast from "../../../../common/components/ui/toast";
import { ToastProvider } from "../../../../common/components/ui/toast/toast.provider";
import MessageTemplateTable from "./MessagesTemplateTable.tsx"

function VehicleTrackersPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <MessageTemplateTable />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default VehicleTrackersPage


